import { useEffect, MutableRefObject } from 'react'

export const useAutofocus = (ref: MutableRefObject<HTMLElement | null>) => {
  useEffect(() => {
    if (ref.current && window.innerWidth >= 640) {
      ref.current.focus()
    }
  }, [ref])
}
